export const createAction = (type: string) => {
  const actionCreator = (payload?: unknown) => ({ type, payload });
  actionCreator.toString = () => type;
  return actionCreator;
};

export const VACANCY_REQUESTED = 'VACANCY_REQUESTED';
export const VACANCY_RECEIVED = 'VACANCY_RECEIVED';
export const VACANCY_REJECTED = 'VACANCY_REJECTED';
export const VACANCY_RESET = 'VACANCY_RESET';

export const requestVacancy = createAction(VACANCY_REQUESTED);
export const receiveVacancy = createAction(VACANCY_RECEIVED);
export const rejectVacancy = createAction(VACANCY_REJECTED);
export const resetVacancy = createAction(VACANCY_RESET);

export const POST_VACANCY_RESPONSE_REQUESTED = 'POST_VACANCY_RESPONSE_REQUESTED';
export const POST_VACANCY_RESPONSE_RECEIVED = 'POST_VACANCY_RESPONSE_RECEIVED';
export const POST_VACANCY_RESPONSE_REJECTED = 'POST_VACANCY_RESPONSE_REJECTED';

export const requestPostVacancyResponse = createAction(POST_VACANCY_RESPONSE_REQUESTED);
export const receivePostVacancyResponse = createAction(POST_VACANCY_RESPONSE_RECEIVED);
export const rejectPostVacancyResponse = createAction(POST_VACANCY_RESPONSE_REJECTED);

export const POST_VACANCY_RECOMMENDATION_REQUESTED = 'POST_VACANCY_RECOMMENDATION_REQUESTED';
export const POST_VACANCY_RECOMMENDATION_RECEIVED = 'POST_VACANCY_RECOMMENDATION_RECEIVED';
export const POST_VACANCY_RECOMMENDATION_REJECTED = 'POST_VACANCY_RECOMMENDATION_REJECTED';

export const requestPostVacancyRecommendation = createAction(POST_VACANCY_RECOMMENDATION_REQUESTED);
export const receivePostVacancyRecommendation = createAction(POST_VACANCY_RECOMMENDATION_RECEIVED);
export const rejectPostVacancyRecommendation = createAction(POST_VACANCY_RECOMMENDATION_REJECTED);

export const DOCUMENTS_REQUESTED = 'DOCUMENTS_REQUESTED';
export const DOCUMENTS_RECEIVED = 'DOCUMENTS_RECEIVED';
export const DOCUMENTS_REJECTED = 'DOCUMENTS_REJECTED';

export const requestDocuments = createAction(DOCUMENTS_REQUESTED);
export const receiveDocuments = createAction(DOCUMENTS_RECEIVED);
export const rejectDocuments = createAction(DOCUMENTS_REJECTED);

export const ERROR_RESET = 'ERROR_RESET';

export const resetErrors = createAction(ERROR_RESET);
